import { authService } from './auth/authService.js';
import { i18n } from './core/i18n.js';
import { initNavigation, switchPipelineMode, showDashboard, updateProjectDropdown, newProject } from './ui/navigation.js';
import { initProposalUI } from './ui/proposal.js';
import { initQuickDocUI } from './ui/quickdoc.js';
import { initAdminUI } from './ui/admin.js';
import { appState } from './core/stateManager.js';

document.addEventListener('DOMContentLoaded', async () => {
    // 1. Initialize Auth (awaited to ensure Firebase dynamically loads first)
    await authService.init();

    // 2. Initialize i18n
    await i18n.init('ko');
    i18n.translateDOM();

    // 3. Bind UI Events & Initialize
    try {
        console.log("🚀 AuraDoc Initializing... [Build: 2026-05-12 21:18:00]");
        
        initNavigation();
        initProposalUI();
        initQuickDocUI();
        
        // Admin UI initialization (wrapped for safety)
        try {
            initAdminUI();
        } catch (adminErr) {
            console.error("⚠️ Admin UI initialization failed:", adminErr);
        }

        // User menu setup will be initiated by authService login/ready events

        // 4. Bind Auth buttons from initial view
        const handleGoogle = () => {
            authService.handleGoogleLogin().then(user => {
                if (user) {
                    // mockLogin already hides the modal and shows the app-wrapper
                }
            }).catch(err => alert(err.message));
        };

        document.getElementById('btn-google-login')?.addEventListener('click', handleGoogle);
        document.getElementById('btn-google-signup')?.addEventListener('click', handleGoogle);

        document.getElementById('btn-local-mode')?.addEventListener('click', () => {
            authService.startLocalMode();
        });

        document.getElementById('btn-email-signup')?.addEventListener('click', () => {
            const email = document.getElementById('signup-email')?.value;
            const pwd = document.getElementById('signup-password')?.value;
            if (email && pwd) authService.handleSignup(email, pwd).catch(err => alert(err.message));
            else alert("이메일과 비밀번호를 입력해주세요.");
        });

        document.getElementById('btn-email-login')?.addEventListener('click', () => {
            const email = document.getElementById('auth-email')?.value;
            const pwd = document.getElementById('auth-password')?.value;
            if (email && pwd) authService.handleLogin(email, pwd).catch(err => alert(err.message));
            else alert("이메일과 비밀번호를 입력해주세요.");
        });

        document.getElementById('btn-show-signup')?.addEventListener('click', () => authService.showSignupView());
        document.getElementById('btn-show-login')?.addEventListener('click', () => authService.showLoginView());
        document.getElementById('btn-close-signup')?.addEventListener('click', () => authService.showLoginView());

        // 5. Layout initialization
        const currentMode = appState.getState().activeMode || 'proposal';
        switchPipelineMode(currentMode);
        updateProjectDropdown();
        
        // 4. Handle External Actions (from Admin Page)
        const urlParams = new URLSearchParams(window.location.search);
        const action = urlParams.get('action');

        if (action === 'new-proposal') {
            const title = urlParams.get('title');
            appState.setState({ activeMode: 'proposal' });
            newProject();
            if (title) {
                appState.setState({ projectData: { ...appState.getState().projectData, name: title } });
                appState.saveCurrentProject();
                updateProjectDropdown();
            }
            switchPipelineMode('proposal');
            window.history.replaceState({}, document.title, window.location.pathname);
        } else if (appState.getState().currentProjectId) {
            console.log(`📂 Loading active project: ${appState.getState().currentProjectId}`);
        } else {
            console.log("🏠 Showing Dashboard");
            showDashboard();
        }


        // Hide splash with a slight delay for smooth transition
        setTimeout(() => {
            const splash = document.getElementById('initial-splash');
            if (splash) {
                splash.style.setProperty('display', 'none', 'important');
                splash.classList.add('hidden');
                console.log("✨ Splash hidden");
            }
            
            // EMERGENCY: Ensure main content and app wrapper are visible only after authenticated/local sessions.
            const appWrap = document.getElementById('app-wrapper');
            const mainContent = document.getElementById('main-content');
            const canRevealApp = authService.authState === 'authenticated';
            if (appWrap && canRevealApp) {
                appWrap.style.setProperty('display', 'flex', 'important');
                appWrap.classList.remove('hidden');
            }
            if (mainContent && canRevealApp) {
                mainContent.style.setProperty('display', 'block', 'important');
                mainContent.classList.remove('hidden');
            }
            console.log("🛠️ Emergency visibility check complete");

        }, 800);

    } catch (err) {
        console.error("❌ Critical Initialization Error:", err);
        document.getElementById('initial-splash')?.classList.add('hidden');
        alert("애플리케이션 초기화 중 오류가 발생했습니다. 콘솔을 확인해주세요.");
    }
});

// Global Error Handler for diagnostics
window.addEventListener('error', (event) => {
    console.error("🔥 Global Runtime Error:", event.error || event.message);
});
window.addEventListener('unhandledrejection', (event) => {
    console.error("🌊 Unhandled Promise Rejection:", event.reason);
});
